import { request } from "@/utils/request";

// 线下培训
const training = {
  // 新增
  addTraining(data) {
    return request({
      method: "POST",
      url: "/api/train/addTrain/add",
      data
    });
  },
  // 获取培训列表
  getTrainList(data) {
    return request({
      method: "POST",
      url: "/api/train/getList/list",
      data
    });
  },
  // 根据培训ID获取培训详情
  getTrainByID(data) {
    return request({
      method: "POST",
      url: "/api/train/getTrainByID/get",
      data
    });
  },
  // 添加学分项
  addTrainByID(data) {
    return request({
      method: "POST",
      url: "/api/train/trainScore/add",
      data
    });
  },
  // 获取学分关联的考试和练习数据详细，点击编辑的时候需要用到
  getTypeDetail(data) {
    return request({
      method: "POST",
      url: "/api/train/trainScore/getTypeDetail",
      data
    });
  },
  // 删除
  delete(data) {
    return request({
      method: "POST",
      url: "/api/train/trainScore/delete",
      data
    });
  },
  // 提交完成 
  config(data) {
    return request({
      method: "POST",
      url: "/api/train/trainScore/config",
      data
    });
  },
  // 修改培训 
  editTraining(data) {
    return request({
      method: "POST",
      url: "/api/train/editTrain/edit",
      data
    });
  },
  // 删除培训
  deleteTraining(data) {
    return request({
      method: "POST",
      url: "/api/train/delTrain/delete",
      data
    });
  },
  // 培训情况页统计 
  trainingCount(data) {
    return request({
      method: "POST",
      url: "/api/train/stat/allDataCount",
      data
    });
  },
   // 培训情况页统计 按选择时间统计完成任务数 
   dayCount(data) {
    return request({
      method: "POST",
      url: "/api/train/stat/dayCount",
      data
    });
  },
  // 获取培训学员学习情况
  getStudyList(data) {
    return request({
      method: "POST",
      url: "/api/train/sudentStat/list",
      data
    });
  },
  // 获取培训学员的学习详情
  getStudetail(data) {
    return request({
      method: "POST",
      url: "/api/train/sudentStat/studetail",
      data
    });
  },
  // 获取学分用于考生端考试和练习提交记录学分
  submitCredit(data) {
    return request({
      method: "POST",
      url: "/api/train/submitTrain/submit",
      data
    });
  },
  // 查看是否有权限开通 
  checkPower(data) {
    return request({
      method: "POST",
      url: "/api/train/isHaveTrain/check",
      data
    });
  },
};

export default training;
